export const FORM_NAME = 'resetPassword'

export const PASSWORD_PROPERTY = 'password'
export const CONFIRM_PASSWORD_PROPERTY = 'confirmPassword'
export const HIDDEN_PROPERTY = 'hiddenField'

export const MIN_LENGTH = 8
export const MAX_LENGTH = 15

// messages
export const RESET_PASSWORD_EMPTY = 'Please enter your password.'

export const CODE_LINK_EXPIRED = '1021'
export const CODE_SAME_PASSWORD = '1018'

